import {
    ADD_REMINDER,
    ADD_REMINDER_FAILED,
    ADD_REMINDER_SUCCESS,
    REMINDER,
    REMINDER_FAILED,
    REMINDER_SUCCESS,
    UPDATE_REMINDER,
    UPDATE_REMINDER_FAILED,
    UPDATE_REMINDER_SUCCESS
} from "./actionTypes"

let initialState = {
    reminder: [],
    addReminder: "",
    loading: false,
    success: false,
    error: ''
}

export const reminderReducer = (state = initialState, action) => {
    switch (action.type) {
        case REMINDER: return {
            ...state,
            loading: true,
            success: false,
            error: ""
        }
        case REMINDER_SUCCESS: return {
            ...state,
            reminder: action.payload,
            loading: false,
            success: true,
        }
        case REMINDER_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload,
        }

        case ADD_REMINDER: return {
            ...state,
            loading: true,
            success: false,
            error: ""
        }
        case ADD_REMINDER_SUCCESS: return {
            ...state,
            addReminder: action.payload,
            reminder: [...state.reminder, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_REMINDER_FAILED: return {
            ...state,
            addReminder: [],
            loading: false,
            success: false,
            error: action.payload,
        }

        case UPDATE_REMINDER: return {
            ...state,
            loading: true,
            success: false,
            error: ""
        }
        case UPDATE_REMINDER_SUCCESS: return {
            ...state,
            updateReminder: action.payload,
            reminder: state.payload.map((item) => item.id === action.payload._id ? action.payload : item),
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_REMINDER_FAILED: return {
            ...state,
            updateReminder: [],
            loading: false,
            success: false,
            error: action.payload,
        }

        default: return state
    }
}